import { ON_SELECTED_CATEGORY, GET_FAQ_CONTENT } from '../../../actions/utils';

export default (state = [], action = {}) => {
  if (action.type === GET_FAQ_CONTENT) {
    return {
      ...state,
      questions: action.payload.questions,
      categories: action.payload.categories,
      isNoCategorySelectedMessage: action.payload.isNoCategorySelectedMessage,
      isNoFAQs: action.payload.isNoFAQs,
      isError: action.payload.isError,
      isLoad: action.payload.isLoad,
    };
  }
  if (action.type === ON_SELECTED_CATEGORY) {
    return {
      ...state,
      questions: action.payload.questions,
      categories: action.payload.categories,
    };
  }

  return state;
};
